import { forwardRef, ReactNode } from 'react';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { FaIcon } from '@atoms/icons';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { FormLabel } from './formLabel';

export type CheckboxProps = MuiCheckboxProps & {
  label?: ReactNode;
  onChange?: (event: React.SyntheticEvent, checked: boolean) => void;
  formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'>;
  labelTooltip?: React.ReactNode | React.ReactNode[] | JSX.Element | JSX.Element[] | undefined;
};
export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(function Checkbox(
  { label, onChange, sx, formControlLabelProps, disabled, required, labelTooltip, ...props },
  ref,
) {
  const theme = useTheme();

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          ref={ref}
          icon={<FaIcon name="square" color={theme.palette.grey[500]} />}
          checkedIcon={<FaIcon name="square-check" color="primary" />}
          sx={{ m: '3px', ...sx }}
          checked={!!props.value}
          {...props}
        />
      }
      label={
        <Typography
          component={'span'}
          sx={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          color={disabled ? theme.palette.action.disabled : undefined}
        >
          <FormLabel disabled={disabled} required={required} tooltip={labelTooltip}>
          {label}
          </FormLabel>
        </Typography>
      }
      onChange={onChange}
      {...formControlLabelProps}
      sx={{
        marginLeft: 0,
        display: 'flex',
        ...formControlLabelProps?.sx,
      }}
    />
  );
});
